import { IAppState } from '../../redux';
import { IPublishTermsService } from '../../redux/reducers';
import { selectServiceById } from './selectServiceById';

export function selectActiveService(state: IAppState): IPublishTermsService | null {
  const {
    publishTerms: { selectedServiceId },
  } = state;

  if (!selectedServiceId) {
    return null;
  }

  return selectServiceById(selectedServiceId, state);
}
